import React, { useState, useContext, useRef } from "react";
import DataTable from "react-data-table-component";
import { IoCloudDownloadOutline } from "react-icons/io5";
import jsPDF from 'jspdf';
import { Modal } from "react-bootstrap";
import 'jspdf-autotable';
import exportFromJSON from "export-from-json";
import dayjs from "dayjs";
// import { FiPrinter } from "react-icons/fi";
// import ReactToPrint from "react-to-print";

//internal import
import PageHeader from "../../components/common/PageHeader";
import ModalLoading from "../../components/Loading/ModalLoading";
import TableLoading from "../../components/Loading/TableLoading";
import useAsync from "../../hooks/useAsync";
import DropDownService from "../../services/DropDownService";
import ReportService from "../../services/ReportService";
import { allContext } from "../../context/AllContext";

function ClientReport() {

    const printRef = useRef();
    const [clientId, setClientId] = useState("");
    const [isViewModal, setIsViewModal] = useState(false);
    const [clientTicketData, setClientTicketData] = useState([]);
    const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
    const { reportSearch, setReportSearch } = useContext(allContext);

    const { data, loading, tableLoading } = useAsync(() => ReportService.getAllClientReportData({ clientId: clientId, fromDate: startDate, toDate: endDate, page: "", limit: "" }));
    const { data: clientDropDown } = useAsync(() => DropDownService.clientDropDown());

    let columnT = ""

    columnT = [
        {
            name: "CLIENT NAME",
            selector: (row) => row.clientName,
            sortable: true,
            cell: (row) => <b>{row.clientName}</b>
        },
        {
            name: "COMPANY",
            selector: (row) => row.companyName,
            sortable: true
        },
        {
            name: "USER NAME",
            selector: (row) => row.username,
            sortable: true,
            cell: row => <div><span className="fw-bold ms-1">{row.username}</span></div>,
            minWidth: "250px"
        },
        {
            name: "EMAIL",
            selector: (row) => row.emailId,
            minWidth: "250px",
            sortable: true
        },
        {
            name: "MOBILE",
            selector: (row) => row.phone,
            sortable: true
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Active" ? 'bg-success' : "bg-warning"}`}>{row.status}</span>
        }
    ];

    const modalColumnT = [
        {
            name: "SUBJECT",
            selector: (row) => row.subject,
            sortable: true,
            wrap: true,
            cell: row => <div><span className="fw-bold ms-1">{row.subject}</span></div>,
        },
        {
            name: "PROJECT",
            selector: (row) => row.projectName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.projectName}</span></div>,
            minWidth: "150px"
        },
        {
            name: "ASSIGNED",
            selector: (row) => row.assigneeName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row.assigneeName}</span></div>,
            minWidth: "150px"
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" ? 'bg-success' : row.status === "Hold" ? "bg-danger" : row.status === "In Progress" ? "bg-primary" : "bg-warning"}`}>{row.status}</span>
        }
    ];

    const handleDownloadReport = async (downloadType) => {
        try {
            const res = await ReportService.getAllClientReportData({ clientId: clientId, fromDate: startDate, toDate: endDate, page: "", limit: "" });
            if (downloadType === "pdf") {
                const exportData = res?.data?.map((val) => {
                    return [
                        val.clientName,
                        val.companyName,
                        val.username,
                        val.emailId,
                        val.phone,
                        val.status
                    ]
                });
                const head = ["CLIENT NAME", "COMPANY", "USER NAME", "EMAIL", "MOBILE", "STATUS"];
                const unit = "pt";
                const size = "A4"; // Use A1, A2, A3 or A4
                const orientation = "landscape"; // portrait or landscape  
                const doc = new jsPDF(orientation, unit, size);
                doc.setFontSize(15);
                const headers = [head];
                let content = {
                    startY: 50,
                    head: headers,
                    body: exportData
                };

                const header = "Client Report";
                const footer = dayjs().format("DD-MM-YYYY hh:mm A");
                const pageSize = doc.internal.pageSize;
                const pageWidth = pageSize.width || pageSize.getWidth();
                const pageHeight = pageSize.height || pageSize.getHeight();

                doc.text(header, 40, 15);
                doc.text("CRM with Sunpro", 500, 15, { baseline: 'top' });
                doc.autoTable(content);
                doc.setFontSize(8);
                doc.text(footer, pageWidth / 1.2, pageHeight - 50, { baseline: 'bottom' });

                doc.save("client-report" + Date.now() + ".pdf");
            }
            else if (downloadType === "csv" || downloadType === "xls") {
                const exportData = res?.data?.map((val) => {
                    return {
                        "CLIENT NAME": val.clientName,
                        "COMPANY": val?.companyName,
                        "USER NAME": val.username,
                        "EMAIL": val.emailId,
                        "MOBILE": val.phone,
                        "STATUS": val.status
                    }
                });
                exportFromJSON({
                    data: exportData,
                    fileName: "client-report" + Date.now(),
                    exportType: downloadType,
                });
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    const handleClearFilter = () => {
        setClientId("");
        setReportSearch(!reportSearch);
    }

    const handleModalOpen = (row) => {
        setClientTicketData(row || []);
        setIsViewModal(true);
    }

    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="Client Report" renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                        </div>
                    }} />
                    <div className="row">
                        <div className="col-lg-12 pb-4 d-flex justify-content-between">
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Start Date</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    max={endDate}
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">End Date</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    min={startDate}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Select Client</label>
                                <select className="form-select" value={clientId} onChange={(e) => setClientId(e.target.value)}>
                                    <option value="">--- All Client ---</option>
                                    {clientDropDown?.data?.map((val, idx) => (
                                        <option key={idx} value={val?.value}>{val?.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="ms-5 mt-4 p-2 py-3 me-2">
                                <button className="btn btn-dark  px-4 me-2" type="submit" onClick={() => handleClearFilter()}><span className="text-white dark:text-gray-200">Reset</span></button>
                                <button className="btn btn-dark  px-4 " type="submit" onClick={() => setReportSearch(!reportSearch)}><span className="text-white dark:text-gray-200">Search</span></button>
                            </div>
                        </div>
                        <div className="col-lg-12 p-4 pt-6 mt-1 d-flex justify-content-end ">
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("csv")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span> CSV </button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("xls")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>EXCEL</button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("pdf")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>PDF</button>
                            {/* <ReactToPrint
                                trigger={() => (
                                    <button  className="btn btn-dark btn-set-task w-sm-100 m-2">
                                        <span className=" me-2 fs-6"><FiPrinter /></span>
                                        Print
                                    </button>
                                )}

                                content={() => printRef.current}
                                documentTitle="Invoice"
                            /> */}
                        </div>
                    </div>
                    <div className="row clearfix g-3 ">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body" ref={printRef}>
                                    <DataTable
                                        title="Users"
                                        columns={columnT}
                                        data={data?.data}
                                        defaultSortField="title"
                                        pagination
                                        selectableRows={false}
                                        className="table  myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                        progressPending={tableLoading}
                                        onRowClicked={(row) => handleModalOpen(row)}
                                        progressComponent={<TableLoading row={10} col={7} width={160} height={20} />}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <Modal show={isViewModal} size="xl" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold w-100 text-center">{clientTicketData?.clientName} Tickets</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="row clearfix g-3" >
                        <div className="col-md-12">
                            <div className="card ">
                                <div className="card-body" ref={printRef} >
                                    <DataTable
                                        title="Employee Attendance Report Modal"
                                        columns={modalColumnT}
                                        data={clientTicketData.tickets || []}
                                        defaultSortField="title"
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                        progressPending={loading}
                                        progressComponent={<ModalLoading loading={loading} />}
                                        fixedHeader
                                        fixedHeaderScrollHeight="450px"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ClientReport;